import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { App as CapApp } from "@capacitor/app";
import { toast } from "sonner";
import api, { storeToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { isNativeApp } from "@/lib/health";
import { sessionIdFromUrl, closeAuthBrowser } from "@/lib/nativeAuth";

/** Catches com.ikavio.app://auth#session_id=… after Google sign-in in the system browser. */
export default function NativeDeepLinks() {
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (!isNativeApp()) return;
    let handle;
    CapApp.addListener("appUrlOpen", async ({ url }) => {
      const sessionId = sessionIdFromUrl(url);
      if (!sessionId) return;
      closeAuthBrowser();
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        storeToken(data.token);
        setUser(data.user);
        navigate(data.user.onboarded ? "/app" : "/onboarding", { replace: true });
      } catch {
        toast.error("Google sign-in failed — please try again.");
        navigate("/login", { replace: true });
      }
    }).then((h) => { handle = h; });
    return () => { handle?.remove?.(); };
  }, [navigate, setUser]);

  return null;
}
